import React, {Component} from 'react';
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import NuevoRegistro from './RAsistencia';
import {getCompanyCollection} from '../../firebase';

class mapEmpleados extends Component{
	constructor(props){
		super(props);
		this.newRegistro = this.newRegistro.bind(this);
		this.cambiarEstado = this.cambiarEstado.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
		this.app= firebase;
		this.database = null;
        this.changeModal= this.props.changeModal;
		this.state = {
            fecha: this.props.fecha,
			empleados: [],
			useModal: false,
		}
	}

	async componentDidMount(){
		this.database = (await getCompanyCollection('Empleados')).where('activo', '==', 'si');
		this.database.onSnapshot(querySnapshot =>{
			this.setState({empleados:[]})
			querySnapshot.forEach(doc=>{
				const previousAct = this.state.empleados;
				previousAct.push({
				id: doc.id,
				nombre: doc.data().Nombre,
				activo: doc.data().activo,
				sueldos: doc.data().sueldos
				})
				this.setState({
					empleados: previousAct
				})
			})
		})
	}

	cambiarEstado(id, estado){
		if (estado === 'Activa'){
			this.database.child(id).update({ estado: "Inactiva", });
		}
		else {
			this.database.child(id).update({ estado: "Activa", });
		};
	}

	newRegistro(asistencia){
        const data = asistencia;
		this.props.newRegistro(data);
	}
	
    cerrarModal(event){
		event.preventDefault()
		this.changeModal(false)
	}
	render(){
		return (
		<div>
        {
            this.state.empleados.sort(({ empleado: previousID }, { empleado: currentID }) => previousID - currentID)
            .map((empleado) => {
                return (
                    <div key={empleado.id}>
                        <NuevoRegistro  newRegistro={this.newRegistro} 
                                        empleado={empleado.nombre} 
                                        fecha={this.state.fecha}
										sueldos={empleado.sueldos}
										cerrar={this.cerrarModal}
                    /></div>
                )
            })
        }
		</div>
		);
	}
}
export default mapEmpleados;
